import { Modal, message } from 'ant-design-vue'
import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'
import router, { healthRoute, homeRoute } from '@/router/index'
import { UserController } from '@/controller'
import { CATEGORY } from '@/controller/home/ServiceController'
// import { UserController } from '@/controller'
// import { useRouter, useRoute } from 'vue-router'

const initState: USER.Detail = {
  id: '',
  tenantId: '',
  token: '',
  email: '',
  account: '',
  label: '用户',
  phone: '',
  agentId: '',
  agent: {
    agentType: 'HEADQUARTERS',
    category: CATEGORY.headquarters
  }
}

// 递归后端的权限数据  -- 菜单
// function filterPermissionArray (route: any) {
//   const roleObj = {
//     arr: [],
//     buttonList: []
//   }
//   for (let i = 0; i < route.length; i++) {
//     roleObj.arr.push(route[i].url)
//     roleObj.buttonList.push(...route[i].buttons)

//     if (route[i].children && route[i].children.length > 0) {
//       const { arr, buttonList } = filterPermissionArray(route[i].children)
//       roleObj.arr.push(...arr)
//       roleObj.buttonList.push(...buttonList)
//     }
//   }
//   return roleObj
// }

// }

export const useUserStore = defineStore('userStore', () => {
  const meuns = ref<any>([])

  const userInfo = ref(initState)

  const roleMeuns = ref([])

  const token = ref('')

  const clearUserInfo = () => {
    return new Promise((resolve) => {
      // 做些什么
      message.loading('清除用户信息中......', 0.5)
      window.localStorage.removeItem('userInfo')
      setTimeout(() => {
        resolve(true)
      }, 500)
    })
  }

  const login = async (data: USER.Params.Login) => {
    // 存储用户信息 跳转页面
    const { code, data: _data } = await UserController.login({ username: data.username, password: data.password })

    if (code === 0) {
      token.value = (_data as any).token
      message.success('登录成功')
      // 获取用户信息
      const data = await UserController.getCurrUser()
      userInfo.value = data
      userInfo.value.agent.category = data.agent.agentType.toLocaleLowerCase() as any
      if (userInfo.value.agentId === '') {
        message.error('暂未分配代理，请联系管理员')
        return
      }
      if (userInfo.value.agent.agentType === 'HEADQUARTERS') {
        router.push({ path: healthRoute.path })
      } else {
        router.push({ path: homeRoute.path })
      }
      // 获取用户路由权限
      // const roleData = await UserController.getCurrMenu()
      // meuns.value = roleData as any

      // router.push({ path: meuns.value[0].path })
      // router.push({ path: '/home' })
    }
  }

  const openUserInfoModal = () => {
    Modal.success({
      title: userInfo.value.label + '的信息',
      content: '需要想到优雅的方式来打开个人信息弹窗',
      cancelText: '取消',
      okText: '确定',
      onCancel: () => {},
      onOk: () => {}
    })
  }

  const logout = () => {
    Modal.confirm({
      title: '您确定要退出吗？',
      cancelText: '取消',
      okText: '确定',
      onCancel: () => {},
      onOk: async () => {
        await clearUserInfo()
        message.success('登出成功')
        // 退出
        router.push({ path: '/login' })
      }
    })
  }

  const autoLogout = async () => {
    await clearUserInfo()
    // 退出
    router.push({ path: '/login' })
  }

  const encryptPassWord = (password: string) => encodeURI(btoa(password))

  const setRoleMeun = (meun: any) => roleMeuns.value = meun

  // 查询用户权限
  // const roleAuth = () => {
  //   return new Promise(async (resolve, reject) => {
  //     await UserController.getRolesAuth()
  //   })
  // }

  return {
    meuns,
    userInfo,
    roleMeuns,
    token,
    setRoleMeun,
    login,
    logout,
    clearUserInfo,
    openUserInfoModal,
    encryptPassWord,
    autoLogout
  }
}, {
  persist: true
})
